import { addEdge } from 'reactflow';


export const onConnectFlowEdges = (newEdge, oldEdges) => addEdge(newEdge, oldEdges);
